export default __webpack_public_path__ + "static/media/L50.79a34693.png";